// Що з нового дизайну (?v2) показуємо. Власник 04.11: поки лишаємо пошук, сортування й кружечки видів піц,
// решту ховаємо — код і вікна лишаються, повернути = true
export const V2_FEATURES = {
    ingredients: false, // «Інгредієнти» — фільтр за складом (BpIngredientFilter.vue)
    ownPizza: false,    // «Склади свою піцу» (BpCustomPizza.vue, src/customPizza.js)
    randomPizza: false, // «Випадкова піца» (BpRandomPizza.vue)
    crowd: false,       // «Скільки піци на компанію» (BpCrowdPizza.vue)
    whoPays: false      // ігри «Хто платить?»: пункт меню, посилання в підвалі, картка в кошику й сама сторінка
};
